export default __webpack_public_path__ + "static/media/gallery_09.05abdca2.jpg";